import Img2 from "../images/testimonials/pfp1.jpg";
import Img3 from "../images/testimonials/pfp2.jpg";

function Testimonials() {
  return (
    <>
      <section className="testimonials-section">
        <div className="container">
          <div className="testimonials-content">
            <div className="testimonials-content__title">
              <h4>Müşteri Yorumları</h4>
              <h2>Müşterilerimizin Deneyimleri</h2>
              <p>
                Müşterilerimizin yorumlarını okuyarak hizmetlerimizin onlar üzerinde
                bıraktığı olumlu etkiyi keşfedin. Müşterilerimiz hizmetlerimizi
                deneyimledi ve olumlu tecrübelerini sizlerle paylaşmak için
                sabırsızlanıyor.
              </p>
            </div>

            <div className="all-testimonials">
              <div className="all-testimonials__box">
                <span className="quotes-icon">
                  <i className="fa-solid fa-quote-right"></i>
                </span>
                <p>
                  "Exvrtise ile aracımı kontrol ettirdim ve muhteşem bir deneyim
                  yaşadım! İşlem çok kolaydı ve fiyatlar oldukça uygundu."
                </p>
                <div className="all-testimonials__box__name">
                  <div className="all-testimonials__box__name__profile">
                    <img src={Img2} alt="user_img" />
                    <span>
                      <h4>Ahmet Y</h4>
                      <p>İstanbul</p>
                    </span>
                  </div>
                </div>
              </div>

              <div className="all-testimonials__box box-2">
                <span className="quotes-icon">
                  <i className="fa-solid fa-quote-right"></i>
                </span>
                <p>
                  "Çok detaylı bir inceleme yapıldı ve raporlama sistemi gerçekten
                  etkileyiciydi. Bu ekspertiz firmasını kesinlikle tavsiye ederim!"
                </p>
                <div className="all-testimonials__box__name">
                  <div className="all-testimonials__box__name__profile">
                    <img src={Img3} alt="user_img" />
                    <span>
                      <h4>Mehmet D</h4>
                      <p>Ankara</p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Testimonials;
